export interface ScrollOptions {
  threshold: number
  disableHysteresis: boolean
}

export const SCROLL_OPTIONS: ScrollOptions = {
  threshold: 100,
  disableHysteresis: true,
}
